import styled from '@emotion/styled'

export const StyleChatInterfaceWrapper = styled.div`
  display: flex;
  gap: 12px;
  height: 86vh;
  background-color: ${(props: any) => props.theme.colors.white};
  padding: 12px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const StyleAvatar = styled.img`
  width: 55px;
  height: 55px;
  border-radius: 100vh;
  background: lightblue;
  object-fit: cover;
  @media (max-width: 768px) {
    width: 35px;
    height: 35px;
  }
`

export const StyleName = styled.p`
  font-size: 16px;
  color: ${(props: any) => props.theme.colors.foundationGrey500};
`
